import { MessageSquare } from "lucide-react"

import type { PluginManifest } from "../types"

export const chatPlugin: PluginManifest = {
  id: "chat",
  name: "Chat Assistant",
  description: "AI chat assistant with document-aware conversations",
  route: "/plugins/chat",
  availability: "upgrading",
  icon: MessageSquare,
  order: 1,
  loadPage: () => import("./pages/ChatPluginPage"),
}
